import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../../errors/responses';

const c = initContract();

export const BundleWeighting = z.object({
  id: z.string(),
  stockLevelId: z.string(),
  customerBundleId: z.string(),
  weighting: z.number()
});

export type BundleWeighting = z.infer<typeof BundleWeighting>;

const BundleWeightingRequest = z.object({
  customerBundleId: z.string(),
  weighting: z.number()
});

export default c.router({
  getBundleWeighting: {
    method: 'GET',
    path: '/msp/:mspId/customer/:customerId/stocklevels/:stockLevelId/bundleweightings/:id',
    responses: {
      200: BundleWeighting,
      ...failedResponses
    }
  },
  createBundleWeighting: {
    method: 'POST',
    path: '/msp/:mspId/customer/:customerId/stocklevels/:stockLevelId/bundleweightings',
    responses: {
      200: BundleWeighting,
      ...failedResponses
    },
    body: BundleWeightingRequest
  },
  updateBundleWeighting: {
    method: 'PUT',
    path: '/msp/:mspId/customer/:customerId/stocklevels/:stockLevelId/bundleweightings/:id',
    responses: {
      200: BundleWeighting,
      ...failedResponses
    },
    body: BundleWeightingRequest
  },
  deleteBundleWeighting: {
    method: 'DELETE',
    path: '/msp/:mspId/customer/:customerId/stocklevels/:stockLevelId/bundleweightings/:id',
    responses: {
      200: z.undefined(),
      ...failedResponses
    },
    body: z.undefined()
  }
});
